"use client";

import React from "react";
import { useWatch } from "react-hook-form";

import { FormField } from "@/components/ui/form";
import { RadioGroup } from "@/components/ui/radio-group";

import OfflineCenter from "./offline-center";

import CourseSection from "../course-section";

function CourseOfflineCenters({ centres }) {
  const courseMode = useWatch({ name: "mode" });

  if (!centres?.length || courseMode !== "offline") return null;

  return (
    <CourseSection id="offline-centres" title="Choose Your Offline Centre">
      <FormField
        name="offlineCentreId"
        render={({ field }) => (
          <RadioGroup
            className="grid lg:grid-cols-3 gap-4"
            onValueChange={field.onChange}
            defaultValue={field.value}
          >
            {centres.map((centre) => (
              <OfflineCenter key={centre.offlineCentreId} centre={centre} />
            ))}
          </RadioGroup>
        )}
      />
    </CourseSection>
  );
}

export default CourseOfflineCenters;
